<!-- 
<div class='container col-12'>
    
    <div class='row'> 
        <div class='col-3'>
            <h1>Directive by status = draft</h1>
            <h1>{{}}</h1>
        </div>
        <div class='col-3'>
            <h1>Directive by status = published</h1>
            <h1>{{}}</h1>
        </div>
        <div class='col-3'>
            <h1>Directive by status = archived</h1>
            <h1>{{}}</h1>
        </div>
    </div>
</div>

 -->
<div class='container d-grid col-12'>
    <div class='row   container d-flex justify-content-center pt-15'>
        <h1 class='col-12 text-center'>Here is all the projects information</h1>
            <div class="card" style="width: 18rem;">    
                <div class="card-body text-center">
                <h5>All projects</h5>
                <p class=" card-text ">{{projects}}</p>
                </div>
            </div>
            <div class="card" style="width: 18rem;">    
                <div class="card-body text-center">
                <h5>Projects when status is draft</h5>
                <p class=" card-text ">{{projectsByStatusDraft}}</p>
                </div>
            </div>
            <div class="card" style="width: 18rem;">    
                <div class="card-body text-center">
                <h5>Projects when status is "in progress"</h5>
                <p class=" card-text ">{{projectsByStatusInProgress}}</p>
                </div>
            </div>
            <div class="card" style="width: 18rem;">    
                <div class="card-body text-center">
                <h5>Projects when status is pending</h5>
                <p class=" card-text ">{{projectsByStatusPending}}</p>
                </div>
            </div>
            <div class="card" style="width: 18rem;">    
                <div class="card-body text-center">
                <h5>Projects when status is finished</h5>
                <p class=" card-text ">{{projectsByStatusFinished}}</p>
                </div>
            </div>
            <div class="card" style="width: 18rem;">    
                <div class="card-body text-center">
                <h5>Projects when status is cancelled</h5>
                <p class=" card-text ">{{projectsByStatusCancelled}}</p>
                </div>
            </div>
    </div>
    <div class='row   container d-flex justify-content-center pt-15'>
        <h1 class='col-12 text-center'>Here is all the procedures information</h1>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>All procedures</h5>
            <p class=" card-text ">{{procedures}}</p>
            </div>
        </div>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>Procedures when status is draft</h5>
            <p class=" card-text ">{{proceduresByStatusDraft}}</p>
            </div>
        </div>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>Procedures when status is published</h5>
            <p class=" card-text ">{{proceduresByStatusPublished}}</p>
            </div>
        </div>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>Procedures when status is archived</h5>
            <p class=" card-text ">{{proceduresByStatusArchived}}</p>
            </div>
        </div>
    </div>
    <div class='row   container d-flex justify-content-center pt-15'>
        <h1 class='col-12 text-center'>Here is all the procedures information</h1>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>All directives</h5>
            <p class=" card-text ">{{directives}}</p>
            </div>
        </div>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>Directives when status is draft</h5>
            <p class=" card-text ">{{directivesByStatusDraft}}</p>
            </div>
        </div>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>Directives when status is published</h5>
            <p class=" card-text ">{{directivesByStatusPublished}}</p>
            </div>
        </div>
        <div class="card" style="width: 18rem;">    
            <div class="card-body text-center">
            <h5>Directives when status is archived</h5>
            <p class=" card-text ">{{directivesByStatusArchived}}</p>
            </div>
        </div>
    </div>
</div>